import {useNavigate} from "react-router-dom";
import {EditLiveEventFormValues} from "../types";
import {message} from "antd";
import {editLiveEventDto} from "../edit-live-event-service";
import {useUpdateLiveEvent, LiveEvent} from "../../../../features/live-events";

interface HookResult {
  editLiveEvent(values: EditLiveEventFormValues): void;
  wasLiveEventEdited: boolean;
  isEditingLiveEvent: boolean;
  responseData?: LiveEvent;
}

export function useEditLiveEventHook(): HookResult {
  const navigate = useNavigate();
  const editLiveEventMutation = useUpdateLiveEvent();

  const editLiveEvent = (values: EditLiveEventFormValues) => {
    editLiveEventMutation.mutate(editLiveEventDto(values), {
      onSuccess() {
        message.success("Updated Successfully");
        navigate("/live-classes");
      },
    });
  };
  return {
    editLiveEvent,
    wasLiveEventEdited: editLiveEventMutation.isSuccess,
    isEditingLiveEvent: editLiveEventMutation.isLoading,
    responseData: editLiveEventMutation.isSuccess
      ? editLiveEventMutation.data
      : undefined,
  };
}
